import React from 'react';
import ProductosComponent from './productos.components';

const ProductosView = () => {
  return (
    <>
    <h3>Productos</h3>
    <ProductosComponent/>
    </>
  )
}

export default ProductosView;